export const jobFunctions = [
  {
    name: 'Administrative Staff',
    desc:
      'General roles and responsibilities include management of reception and front desk, verifying patient eligibility, billing and medical coding, transcription processing, information technology (IT) management, administrative assistant tasks and executive management duties.',
    category: 'Administrative Staff',
    order: 0,
    id: '0',
    isNpiRequired: false,
    isActive: true,
    code: 'AS',
  },
  {
    name: 'Clinical Support Staff',
    desc:
      'General roles and responsibilities include obtaining and documenting patient vital signs and medical history, administering diagnostic tests and utilizing and maintaining medical equipment.',
    category: 'Clinical Staff',
    order: 1,
    id: '1',
    isNpiRequired: false,
    isActive: true,
    code: 'SS',
  },
  {
    name: 'Clinician',
    desc:
      'General roles and responsibilities include prescribing medication, creating treatment plan, providing prognosis based on clinical evaluation and treatment plan, updating patient’s medical records, and providing referrals to other providers if appropriate. Clinicians are required to provide their individual National Provider Identification Number (NPI).',
    category: 'Clinical Staff',
    order: 2,
    id: '2',
    isNpiRequired: true,
    isActive: true,
    code: 'C',
  },
  {
    name: 'Physician',
    desc:
      'General roles and responsibilities are the same as clinician but must be a practicing physician with an M.D. or D.O. license. ',
    category: 'Clinical Staff',
    order: 3,
    id: '3',
    isNpiRequired: true,
    isActive: true,
    code: 'P',
  },
];
